export const environment = {
  production: true,
  cvrtUrl: 'https://cvrt.kronas.dev/api',
  projectUrl: 'https://cvrt.kronas.dev',
  testSv: 'https://test-sv.kronas.dev',
  apiUrl: 'https://auth.kronas.dev/api/v1',
  appUrl: 'https://my.kronas.dev/',
  masterKronasUrl: 'https://master.kronas.dev',
  appKey: 'rmpMBXmPHEHsdljFUWkVyJbJYrSuMtEHjRlkE4ae',
  newPesonal: 'https://my2.kronas.dev',
};
